"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.find"));
var _lodash2 = _interopRequireDefault(require("lodash.noop"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _setHours = _interopRequireDefault(require("date-fns/setHours"));
var _getHours = _interopRequireDefault(require("date-fns/getHours"));
var _setMinutes = _interopRequireDefault(require("date-fns/setMinutes"));
var _getMinutes = _interopRequireDefault(require("date-fns/getMinutes"));
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenButton = _interopRequireWildcard(require("@8x8/oxygen-button"));
var _oxygenCalendar = _interopRequireWildcard(require("@8x8/oxygen-calendar"));
var _oxygenLabel = _interopRequireDefault(require("@8x8/oxygen-label"));
var _oxygenInput = _interopRequireDefault(require("@8x8/oxygen-input"));
var _oxygenTimeSelector = _interopRequireDefault(require("@8x8/oxygen-time-selector"));
var _oxygenDateTimeBase = require("@8x8/oxygen-date-time-base");
var _constants = _interopRequireDefault(require("../utils/constants"));
var _StyledDateTimeRangeSelectorDropdown = require("../styled/StyledDateTimeRangeSelectorDropdown");
var _DateTimeRangeSelectorPredefinedList = _interopRequireDefault(require("./DateTimeRangeSelectorPredefinedList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var setHoursAndMinutes = function setHoursAndMinutes(date, hours, minutes) {
  return (0, _setHours["default"])((0, _setMinutes["default"])(date, minutes), hours);
};
var DateTimeRangeSelectorDropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateTimeRangeSelectorDropdown, _PureComponent);
  var _super = _createSuper(DateTimeRangeSelectorDropdown);
  function DateTimeRangeSelectorDropdown(props) {
    var _this;
    _classCallCheck(this, DateTimeRangeSelectorDropdown);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onPredefinedListItemChange", function (_ref) {
      var id = _ref.id,
        value = _ref.value;
      var predefinedRanges = _this.props.predefinedRanges;
      var currentRange = (0, _lodash["default"])(predefinedRanges, {
        id: id
      });
      if (!currentRange) {
        _this.setState({
          predefinedRange: {
            id: _constants["default"]
          }
        });
        return;
      }
      var dateTimeRange = currentRange.dateTimeRange;
      var dateRange = dateTimeRange(value);
      _this.setState({
        predefinedRange: {
          id: id,
          value: value
        },
        dateRange: dateRange,
        calendarRange: dateRange
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onApply", function () {
      var _this$props = _this.props,
        onClose = _this$props.onClose,
        onRangeChange = _this$props.onRangeChange;
      var _this$state = _this.state,
        predefinedRange = _this$state.predefinedRange,
        _this$state$dateRange = _this$state.dateRange,
        startDate = _this$state$dateRange.startDate,
        endDate = _this$state$dateRange.endDate;
      if (_this.timeRangeIsInvalid()) {
        _this.setState({
          isEndTimeValid: false
        });
        return;
      }
      onClose();
      var id = predefinedRange.id;
      if (id !== _constants["default"]) {
        onRangeChange({
          predefinedRange: _objectSpread({}, predefinedRange)
        });
        return;
      }
      onRangeChange({
        dateTime: {
          startDate: new Date(startDate),
          endDate: new Date(endDate)
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var _this$props2 = _this.props,
        onClose = _this$props2.onClose,
        onRangeChange = _this$props2.onRangeChange;
      onClose();
      onRangeChange({});
    });
    _defineProperty(_assertThisInitialized(_this), "onCalendarRangeChange", function (_ref2) {
      var startDate = _ref2.startDate,
        endDate = _ref2.endDate;
      var _this$state$dateRange2 = _this.state.dateRange,
        currentStartDate = _this$state$dateRange2.startDate,
        currentEndDate = _this$state$dateRange2.endDate;
      var startHours = (0, _getHours["default"])(currentStartDate);
      var startMinutes = (0, _getMinutes["default"])(currentStartDate);
      var endHours = (0, _getHours["default"])(currentEndDate);
      var endMinutes = (0, _getMinutes["default"])(currentEndDate);
      _this.setState({
        dateRange: {
          startDate: setHoursAndMinutes(startDate, startHours, startMinutes),
          endDate: setHoursAndMinutes(endDate || startDate, endHours, endMinutes)
        },
        predefinedRange: {
          id: _constants["default"]
        },
        calendarRange: {
          startDate: startDate,
          endDate: endDate
        }
      }, _this.validateTimeRangeOnDateTimeChange);
    });
    _defineProperty(_assertThisInitialized(_this), "onStartTimeChange", function (time) {
      if (!time) {
        _this.setState(function (_ref3) {
          var _ref3$dateRange = _ref3.dateRange,
            startDate = _ref3$dateRange.startDate,
            endDate = _ref3$dateRange.endDate;
          return {
            dateRange: {
              startDate: startDate,
              endDate: endDate
            }
          };
        });
        return;
      }
      _this.setState(function (_ref4) {
        var _ref4$dateRange = _ref4.dateRange,
          startDate = _ref4$dateRange.startDate,
          endDate = _ref4$dateRange.endDate;
        return {
          dateRange: {
            startDate: setHoursAndMinutes(startDate, time.hours, time.minutes),
            endDate: endDate
          },
          predefinedRange: {
            id: _constants["default"]
          }
        };
      }, _this.validateTimeRangeOnDateTimeChange);
    });
    _defineProperty(_assertThisInitialized(_this), "onEndTimeChange", function (time) {
      if (!time) {
        _this.setState(function (_ref5) {
          var _ref5$dateRange = _ref5.dateRange,
            startDate = _ref5$dateRange.startDate,
            endDate = _ref5$dateRange.endDate;
          return {
            dateRange: {
              startDate: startDate,
              endDate: endDate
            }
          };
        });
        return;
      }
      _this.setState(function (_ref6) {
        var _ref6$dateRange = _ref6.dateRange,
          startDate = _ref6$dateRange.startDate,
          endDate = _ref6$dateRange.endDate;
        return {
          dateRange: {
            startDate: startDate,
            endDate: setHoursAndMinutes(endDate, time.hours, time.minutes)
          },
          predefinedRange: {
            id: _constants["default"]
          }
        };
      }, _this.validateTimeRangeOnDateTimeChange);
    });
    _defineProperty(_assertThisInitialized(_this), "getState", function () {
      var _this$props3 = _this.props,
        predefinedRange = _this$props3.predefinedRange,
        predefinedRanges = _this$props3.predefinedRanges,
        dateTimeRange = _this$props3.dateTimeRange;
      var id = predefinedRange.id,
        value = predefinedRange.value;
      if (id !== _constants["default"]) {
        var currentRange = (0, _lodash["default"])(predefinedRanges, {
          id: id
        });
        if (currentRange) {
          var currentDateTimeRange = currentRange.dateTimeRange;
          var dateRange = currentDateTimeRange(value);
          return {
            predefinedRange: predefinedRange,
            dateRange: dateRange,
            calendarRange: dateRange
          };
        }
      }
      if (dateTimeRange) {
        return {
          predefinedRange: {
            id: _constants["default"]
          },
          dateRange: dateTimeRange,
          calendarRange: dateTimeRange
        };
      }
      return {
        predefinedRange: {
          id: _constants["default"]
        },
        dateRange: {
          startDate: setHoursAndMinutes(new Date(), 0, 0),
          endDate: setHoursAndMinutes(new Date(), 23, 59)
        },
        calendarRange: {
          startDate: setHoursAndMinutes(new Date(), 0, 0),
          endDate: setHoursAndMinutes(new Date(), 23, 59)
        }
      };
    });
    _defineProperty(_assertThisInitialized(_this), "updateRangeStates", function (state) {
      _this.setState(state);
    });
    _defineProperty(_assertThisInitialized(_this), "timeRangeIsInvalid", function () {
      var _this$state$dateRange3 = _this.state.dateRange,
        startDate = _this$state$dateRange3.startDate,
        endDate = _this$state$dateRange3.endDate;
      return endDate && (0, _isBefore["default"])(endDate, startDate);
    });
    _defineProperty(_assertThisInitialized(_this), "validateTimeRangeOnDateTimeChange", function () {
      var isEndTimeValid = _this.state.isEndTimeValid;
      if (isEndTimeValid) {
        return;
      }
      if (!_this.timeRangeIsInvalid()) {
        _this.setState({
          isEndTimeValid: true
        });
      }
    });
    var defaultState = _this.getState();
    _this.state = _objectSpread({
      isEndTimeValid: true
    }, defaultState);
    return _this;
  }
  _createClass(DateTimeRangeSelectorDropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        dateTimeRange = _this$props4.dateTimeRange,
        predefinedRange = _this$props4.predefinedRange;
      var previousDateTimeRange = prevProps.dateTimeRange,
        previousPredefinedRange = prevProps.predefinedRange;
      if (predefinedRange === previousPredefinedRange && dateTimeRange === previousDateTimeRange) {
        return;
      }
      this.updateRangeStates(this.getState());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        theme = _this$props5.theme,
        clearButtonLabel = _this$props5.clearButtonLabel,
        otherCalendarProps = _this$props5.otherCalendarProps,
        finishButtonLabel = _this$props5.finishButtonLabel,
        hidePredefinedRanges = _this$props5.hidePredefinedRanges,
        hideTime = _this$props5.hideTime,
        fromLabel = _this$props5.fromLabel,
        startTimeLabel = _this$props5.startTimeLabel,
        toLabel = _this$props5.toLabel,
        endTimeLabel = _this$props5.endTimeLabel,
        endTimeErrorMessage = _this$props5.endTimeErrorMessage,
        predefinedRanges = _this$props5.predefinedRanges,
        testId = _this$props5.testId,
        dateFormat = _this$props5.dateFormat,
        timeFormat = _this$props5.timeFormat,
        locale = _this$props5.locale,
        dropdownRef = _this$props5.dropdownRef,
        style = _this$props5.style,
        headerRenderer = _this$props5.headerRenderer,
        customPredefinedRangeLabel = _this$props5.customPredefinedRangeLabel;
      var _this$state2 = this.state,
        predefinedRange = _this$state2.predefinedRange,
        isEndTimeValid = _this$state2.isEndTimeValid,
        _this$state2$dateRang = _this$state2.dateRange,
        startDate = _this$state2$dateRang.startDate,
        endDate = _this$state2$dateRang.endDate,
        calendarRange = _this$state2.calendarRange;
      var startTimeValue = {
        hours: (0, _getHours["default"])(startDate),
        minutes: (0, _getMinutes["default"])(startDate),
        seconds: 0
      };
      var endTimeValue = {
        hours: (0, _getHours["default"])(endDate),
        minutes: (0, _getMinutes["default"])(endDate),
        seconds: 0
      };
      return /*#__PURE__*/_react["default"].createElement(_oxygenDateTimeBase.BasePopperContainer, {
        ref: dropdownRef,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_oxygenDateTimeBase.BaseDropdownContainer, (0, _oxygenConfig.getTestAttributes)("".concat(testId)), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.Content, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CONTENT")), !hidePredefinedRanges && /*#__PURE__*/_react["default"].createElement(_DateTimeRangeSelectorPredefinedList["default"], {
        theme: theme,
        testId: "".concat(testId, "_PREDEFINED_LIST"),
        ranges: predefinedRanges,
        selectedRange: predefinedRange,
        customPredefinedRangeLabel: customPredefinedRangeLabel,
        onRangeSelect: this.onPredefinedListItemChange
      }), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.CalendarContainer, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CALENDAR_CONTAINER")), headerRenderer && headerRenderer(this.props), !hideTime && !headerRenderer && /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.DateTimeInputs, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_TIME_INPUTS")), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.DateTimeInputContainer, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_TIME_INPUT_CONTAINER_START")), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.DateInput, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_INPUT_START")), /*#__PURE__*/_react["default"].createElement(_oxygenLabel["default"], {
        value: fromLabel,
        testId: "".concat(testId, "_DATE_INPUT_START_LABEL")
      }), /*#__PURE__*/_react["default"].createElement(_oxygenInput["default"], _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_INPUT_START_FIELD")), {
        fixed: true,
        value: (0, _format["default"])(startDate, dateFormat, {
          locale: locale
        }),
        size: "small"
      }))), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.TimeInput, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_TIME_INPUT_START")), /*#__PURE__*/_react["default"].createElement(_oxygenLabel["default"], {
        value: startTimeLabel,
        testId: "".concat(testId, "_TIME_INPUT_START_LABEL")
      }), /*#__PURE__*/_react["default"].createElement(_oxygenTimeSelector["default"], {
        timeDisplayFormat: timeFormat,
        size: "small",
        placeholder: startTimeLabel,
        value: startTimeValue,
        testId: "".concat(testId, "_START_TIME_SELECTOR"),
        onChange: this.onStartTimeChange
      }))), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.DateTimeInputContainer, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_TIME_INPUT_CONTAINER_END")), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.DateInput, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_INPUT_END")), /*#__PURE__*/_react["default"].createElement(_oxygenLabel["default"], {
        value: toLabel,
        testId: "".concat(testId, "_DATE_INPUT_END_LABEL")
      }), /*#__PURE__*/_react["default"].createElement(_oxygenInput["default"], _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_INPUT_END_FIELD")), {
        fixed: true,
        value: (0, _format["default"])(endDate, dateFormat, {
          locale: locale
        }),
        size: "small"
      }))), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.TimeInput, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_TIME_INPUT_END")), /*#__PURE__*/_react["default"].createElement(_oxygenLabel["default"], {
        value: endTimeLabel,
        testId: "".concat(testId, "_TIME_INPUT_END_LABEL")
      }), /*#__PURE__*/_react["default"].createElement(_oxygenTimeSelector["default"], {
        hasError: !isEndTimeValid,
        timeDisplayFormat: timeFormat,
        size: "small",
        placeholder: endTimeLabel,
        value: endTimeValue,
        testId: "".concat(testId, "_END_TIME_SELECTOR"),
        onChange: this.onEndTimeChange
      })), !isEndTimeValid && /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.EndTimeError, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_DATE_TIME_INPUTS_ERROR")), endTimeErrorMessage))), /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorDropdown.CalendarWrapper, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CALENDAR_WRAPPER")), /*#__PURE__*/_react["default"].createElement(_oxygenCalendar["default"], _extends({}, otherCalendarProps, {
        testId: "".concat(testId, "_CALENDAR"),
        displayMode: _oxygenCalendar.DISPLAY_MODE.DATE_RANGE,
        showMonthYearPickers: false,
        locale: locale,
        range: calendarRange,
        onRangeChange: this.onCalendarRangeChange,
        enableMaxWidth: false
      }))))), /*#__PURE__*/_react["default"].createElement(_oxygenDateTimeBase.BaseDropdownFooter, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_FOOTER")), /*#__PURE__*/_react["default"].createElement(_oxygenButton.ButtonGroup, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_BUTTON_GROUP")), {
        small: true
      }), /*#__PURE__*/_react["default"].createElement(_oxygenButton["default"], {
        testId: "".concat(testId, "_FINISH_BUTTON"),
        size: _oxygenButton.buttonSize.small,
        onClick: this.onApply,
        isDisabled: !isEndTimeValid
      }, finishButtonLabel), /*#__PURE__*/_react["default"].createElement(_oxygenButton["default"], {
        testId: "".concat(testId, "_CLEAR_BUTTON"),
        variant: _oxygenButton.buttonVariant.secondary,
        size: _oxygenButton.buttonSize.small,
        onClick: this.onClear
      }, clearButtonLabel)))));
    }
  }]);
  return DateTimeRangeSelectorDropdown;
}(_react.PureComponent);
DateTimeRangeSelectorDropdown.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  clearButtonLabel: _propTypes["default"].string.isRequired,
  finishButtonLabel: _propTypes["default"].string.isRequired,
  otherCalendarProps: _propTypes["default"].object,
  hidePredefinedRanges: _propTypes["default"].bool,
  hideTime: _propTypes["default"].bool,
  endTimeErrorMessage: _propTypes["default"].string.isRequired,
  fromLabel: _propTypes["default"].string.isRequired,
  startTimeLabel: _propTypes["default"].string.isRequired,
  toLabel: _propTypes["default"].string.isRequired,
  endTimeLabel: _propTypes["default"].string.isRequired,
  predefinedRanges: _propTypes["default"].array.isRequired,
  predefinedRange: _propTypes["default"].object.isRequired,
  customPredefinedRangeLabel: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func,
  onRangeChange: _propTypes["default"].func.isRequired,
  dateTimeRange: _propTypes["default"].object,
  testId: _propTypes["default"].string,
  dateFormat: _propTypes["default"].string.isRequired,
  timeFormat: _propTypes["default"].string.isRequired,
  locale: _propTypes["default"].object,
  dropdownRef: _propTypes["default"].func,
  style: _propTypes["default"].object.isRequired,
  headerRenderer: _propTypes["default"].func
};
DateTimeRangeSelectorDropdown.defaultProps = {
  otherCalendarProps: {},
  hidePredefinedRanges: false,
  hideTime: false,
  onClose: _lodash2["default"],
  testId: 'DATE_TIME_RANGE_SELECTOR_DROPDOWN',
  dropdownRef: undefined,
  dateTimeRange: undefined,
  locale: undefined,
  headerRenderer: undefined
};
var _default = DateTimeRangeSelectorDropdown;
exports["default"] = _default;